import type { UIEvent } from 'react';

import config from 'config';
import type { DataTracking } from 'core/middlewares/trackingGA4';
import { app } from 'core';

import { ListComponentsTalkTo } from './components/components.styles';
import { ListComponentIsRow } from './components/ListComponentsIsRow';
import { ListComponentIsNotRow } from './components/ListComponentIsNotRow';

export const TalkTo = ({ isRow = false }: { isRow?: boolean }) => {
  const { trackClick } = app.commands.useAppCommand();
  const isMobile = app.hooks.useApp('isMobile');

  const handleTrackClick = (event: UIEvent<HTMLAnchorElement>) => {
    const {
      currentTarget: { dataset },
    } = event;
    const trackData = {
      eventAction: 'clique:rodape',
      eventCategory: 'geral',
      eventLabel: dataset.label,
    } as DataTracking;

    trackClick(event, 'event', trackData);
  };

  return (
    <ListComponentsTalkTo.Ul>
      <ListComponentsTalkTo.Li>
        Atendimento de {config.communication.sac.openingHours.week.days.toLocaleLowerCase()}, das{' '}
        {config.communication.sac.openingHours.week.hours}.{' '}
        {config.communication.sac.openingHours.weekend.days}, das{' '}
        {config.communication.sac.openingHours.weekend.hours}.
      </ListComponentsTalkTo.Li>
      {isRow ? (
        <ListComponentIsRow handleTrackClick={handleTrackClick} />
      ) : (
        <ListComponentIsNotRow handleTrackClick={handleTrackClick} />
      )}
    </ListComponentsTalkTo.Ul>
  );
};
